import React, { useEffect, useState, useCallback } from "react";
import "../DoctorConsole.scss";
import { IconButton, Tooltip } from "@mui/material";
import { useTimer, useStopwatch, useTime } from "react-timer-hook";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
const DigitalClock = () => {
  const { seconds, minutes, hours, isRunning, start, pause, reset } =
    useStopwatch();
  const {
    seconds: digSec,
    minutes: digMin,
    hours: digHr,
    ampm,
  } = useTime({ format: "12-hour" }); // Set autoStart to true
  //   console.log("Digital Clock Rerenders");

  const [displayTime, setDisplayTime] = useState({
    digHr,
    digMin,
    digSec,
    ampm,
    hours,
    minutes,
    seconds,
  });

  useEffect(() => {
    start();
  }, []);

  const handleStartPause = useCallback(() => {
    if (isRunning) {
      pause();
    } else {
      start();
    }
  }, [isRunning, pause, start]);

  // Format with leading zeros
  const formatTime = (val) => String(val).padStart(2, "0");

  const formatHours = (val) => String(val).padStart(2, "0"); // allows 2+ digits
  const formatMinutesSeconds = (val) => String(val).padStart(2, "0").slice(-2);
  // Fix for 12-hour format (00 -> 12)
  const formatHour12 = (hr) => (hr === 0 ? 12 : hr);

  return (
    <div>
      {/* digital clock commented */}
      {/* <h2 className="console-heading" style={{ marginBottom: "2px" }}>
        {`${formatTime(formatHour12(digHr))}:${formatTime(digMin)}:${formatTime(
          digSec
        )} ${ampm.toUpperCase()}`}
      </h2> */}
      <div
        style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
      >
        <h2 className="console-heading" style={{ marginBottom: "0px" }}>
          <h2 className="console-heading" style={{ marginBottom: "0px" }}>
            {`${formatHours(hours)}:${formatMinutesSeconds(
              minutes
            )}:${formatMinutesSeconds(seconds)}`}
          </h2>
        </h2>
        <Tooltip title={isRunning ? "Pause" : "Start"}>
          <IconButton onClick={handleStartPause}>
            {isRunning ? <PauseIcon /> : <PlayArrowIcon />}
          </IconButton>
        </Tooltip>
        <Tooltip title="Reset">
          <IconButton onClick={reset}>
            <RestartAltIcon />
          </IconButton>
        </Tooltip>
      </div>
    </div>
  );
};

export default DigitalClock;
